import {loadArrangementListMainContent} from '../helpers/arrangementListPageHelpers';

class ArrangementListPage {
	constructor() {
		this.init();
	}
	
	init() {
		loadArrangementListMainContent({
			'withStickyFiltersAndSorting': true
		});
	}
	
}

new ArrangementListPage();